<template>
  <div>
    <table class="table table-bordered">
      <thead>
        <tr>
          <th>Name</th>
          <th></th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="group in groups">
          <td>{{ group.name }}</td>
          <td>
            <button type="button" class="btn btn-sm btn-info" @click="edit(group)">Edit</button>
            <button type="button" class="btn btn-sm btn-danger" @click="remove(group)">Delete</button>
          </td>
        </tr>
      </tbody>

    </table>

    <loading :loading="loading"></loading>
  </div>
</template>


<script>
export default {
  props: ['groups'],
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    edit(group) {
      let name = window.prompt('Client Group Name:', group.name)
      if (name) {
        this.loading = true
        this.$store.dispatch('updateGroup', {id: group.id, name})
          .finally(() => {
            this.loading = false
          })
      } else if (name === '') {
        window.alert('The name can not be empty!')
      }
    },
    remove(group) {
      if (window.confirm(`Are you sure you want to delete group ${group.name}`)) {
        this.loading = true
        this.$store.dispatch('deleteGroup', group.id)
          .finally(() => {
            this.loading = false
          })
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/-service-app/components/tables/GroupsTable.vue